import {PageContext} from "vike/types";

export function title(pageContext: PageContext<any>) {
  return pageContext.data?.title || "Ja, Rock!";
}